<a mat-button [matMenuTriggerFor]="menu" class="tool params" hideIfNot="ROLE_ADMINISTRATION">
    <img src="assets/pictogrammes/parametres.svg" class="img-invert img-toolbar" matTooltip="Paramètres">
    <mat-menu #menu="matMenu">
        <button routerLink="/escli/users" hideIfNot="ROLE_ADMINISTRATION" mat-menu-item>Utilisateurs</button>
        <button routerLink="/escli/linge-hebergement-param" hideIfNot="ROLE_HEBERGEMENT" mat-menu-item>Linge
            d'hébergement</button>
        <button routerLink="/escli/dav-param" hideIfNot="ROLE_DAV" mat-menu-item>DAV</button>
    </mat-menu>
</a>
<a (click)="showBasket()" class="tool shopping_basket">
    <mat-badge [matBadge]="basketCount | async " matBadgeColor="{{isWarning() ? 'accent' : 'primary'}}" [matBadgeHidden]="isBasketHidden() | async"
        class="custom-badge"></mat-badge>
    <img src="assets/pictogrammes/panier.svg" class="img-invert img-toolbar" matTooltip="Panier">

</a>
<a routerLink="/escli/contact-us/contact-form" class="tool contact">
    <img src="assets/pictogrammes/contact.svg" class="img-invert img-toolbar" matTooltip="Nous contacter">
</a>
<a routerLink="/escli/profile" class="tool person">
    <img src="assets/pictogrammes/personnes.svg" class="img-invert img-toolbar" matTooltip="Profil">
</a>
<img src="assets/pictogrammes/power.svg" class="img-invert img-toolbar img-click" (click)="logout()"
    matTooltip="Déconnexion">